import { Component, EventEmitter, Output } from '@angular/core';

import { ModalService } from '@base/common/services/modal.service';

import { ModalComponent } from '@shared/modal/modal.component';

@Component({
    selector: 'checkout-click-collect-incompatibility',
    templateUrl: './click-collect-modal.component.html',
    styleUrl: 'click-collect-modal.component.scss',
    standalone: true,
})
export class ClickCollectIncompatibilityModalComponent extends ModalComponent {
    public modalRef: ModalService;
    public title = 'Click & Collect ou accessoire : il faut choisir';
    @Output() public validateEvent = new EventEmitter<boolean>();

    public validate(): void {
        this.validateEvent.emit();
        this._close();
    }

    public continue(): void {
        this._close();
    }

    private _close(): void {
        this.modalRef.close();
    }
}
